import Vue from "vue";
const vm = new Vue();

export const createBatch = async (phone_number) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .post(
        vm.$API_URL + "/dropoff/kerry/batch",
        {
          phone_number: phone_number,
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        let data = res.data.data;
        if (!res.data.status) {
          if (res.data.error.hasOwnProperty("notices")) {
            reject(
              "เบอร์โทรศัพท์ที่ลูกค้ายืนยันตัวตนไม่สามารถใช้งาน Kerry Dropoff ได้ กรุณากดเปิดบิลใหม่และยืนยันตัวตนอีกครั้ง"
            );
          } else {
            reject(res.data.error.message);
          }
        }
        resolve(data);
      });
  });
};

export const deleteBatch = async (batch_no) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .delete(vm.$API_URL + "/dropoff/kerry/batch", {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
        data: {
          batch_no: batch_no,
        },
      })
      .then((res) => {
        let data = res.data.data;
        if (!res.data.status) {
          if (
            res.data.error.message ==
            "Error call to confirm batch(Batch number has been closed.)"
          ) {
            reject(
              "ไม่สามารถยกเลิก BatchId ได้ เนื่องจาก BatchId ได้ถูกคอนเฟิร์มแล้ว"
            );
          } else if (
            res.data.error.message ==
            "Error call to confirm batch(Batch number has been canceled.)"
          ) {
            reject(
              "ไม่สามารถยกเลิก BatchId ได้ เนื่องจาก BatchId ได้ถูกยกเลิกแล้ว"
            );
          } else {
            reject(res.data.error.message);
          }
        }
        resolve(data);
      });
  });
};

export const addShipment = async (
  batch_no,
  consignment_no,
  consignment_index
) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .post(
        vm.$API_URL + "/dropoff/kerry/batch/shipment",
        {
          batch_no: batch_no,
          consignment_no: consignment_no,
          consignment_index: consignment_index,
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        let data = res.data.data;
        if (!res.data.status) {
          if (res.data.error.hasOwnProperty("notices")) {
            if (res.data.error.notices.consignment_no) {
              reject("หมายเลขพัสดุไม่ถูกต้องหรือระบบไม่รองรับเลขพัสดุนี้");
            } else
              reject(
                "ไม่สามารถสร้างรายการ Kerry Dropoff ได้ เนื่องจากไม่มี BatchId"
              );
          } else {
            let errorMsg = res.data.error.message.split("[");
            if (
              errorMsg[0] ==
              "Error call to add shipmentItems(Consignment number already. "
            ) {
              reject(
                `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจากหมายเลขพัสดุ ${consignment_no} นี้ ถูกใช้งานไปแล้ว`
              );
            } else {
              reject(res.data.error.message);
            }
          }
        }
        resolve(data);
      });
  });
};

export const deleteShipment = async (
  batch_no,
  consignment_no,
  consignment_no_ref
) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .delete(vm.$API_URL + "/dropoff/kerry/batch/shipment", {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
        data: {
          batch_no: batch_no,
          consignment_no: consignment_no,
          consignment_no_ref: consignment_no_ref,
        },
      })
      .then((res) => {
        let data = res.data.data;
        if (!res.data.status) {
          reject(res.data.error.message);
        }
        resolve(data);
      });
  });
};
